var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarConsumption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3237 17.4008L10.686 15.2258H3.62474V14.5006C3.62474 14.1016 3.2985 13.7754 2.89952 13.7754H0.725221C0.326247 13.7754 0 14.1016 0 14.5006V28.2757C0 28.6747 0.326247 29.001 0.725221 29.001H7.25017C7.64914 29.001 7.97539 28.6747 7.97539 28.2757C7.97539 27.8768 7.64914 27.5505 7.25017 27.5505H3.62542V16.6756H5.67738L5.48164 17.4008H10.3244H10.3237Z",
    fill: "#FFFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3193 15.2258L18.6816 17.4008H23.5175L23.3218 16.6756H25.3737V27.5505H21.749C21.35 27.5505 21.0238 27.8768 21.0238 28.2757C21.0238 28.6747 21.35 29.001 21.749 29.001H28.2739C28.6729 29.001 28.9991 28.6747 28.9991 28.2757V14.5006C28.9991 14.1016 28.6729 13.7754 28.2739 13.7754H26.0989C25.7 13.7754 25.3737 14.1016 25.3737 14.5006V15.2258H18.3125H18.32H18.3193Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0863 18.8496H5.10558L4.38036 21.5609C4.32259 21.7784 4.36609 22.0101 4.50339 22.1916C4.64068 22.3731 4.85138 22.4744 5.07636 22.4744H9.4773L10.0788 18.8496H10.0863Z",
    fill: "#FFFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0585 22.475H10.9531L11.5553 18.8496H17.4563L18.0585 22.475Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9294 18.8496L19.5309 22.4744H23.9318C24.1568 22.4744 24.3668 22.3731 24.5048 22.1916C24.6428 22.0101 24.6863 21.7784 24.6278 21.5609L23.9026 18.8496H18.9219H18.9294Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2165 17.3996H11.8008L12.1637 15.2246H16.8542L17.2165 17.3996Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5436 10.1504H7.9909C7.66465 10.1504 7.37443 10.3679 7.28743 10.6867L6.46094 13.7751H10.9339L11.5354 10.1504H11.5429H11.5436Z",
    fill: "#FFFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6153 13.7758H12.4102L13.0124 10.1504H16.0138L16.6153 13.7758Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4886 10.1504L18.0901 13.7751H22.5631L21.7366 10.6867C21.6496 10.3679 21.3669 10.1504 21.0332 10.1504H17.4805H17.4879H17.4886Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2395 8.70037V7.25061C15.2395 6.85164 14.9133 6.52539 14.5143 6.52539C14.1153 6.52539 13.7891 6.85164 13.7891 7.25061V8.70037C13.7891 9.09935 14.1153 9.42559 14.5143 9.42559C14.9133 9.42559 15.2395 9.09935 15.2395 8.70037Z",
    fill: "#FFFEFE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0792 6.48821L18.1015 7.51045C18.3842 7.7932 18.841 7.7932 19.1237 7.51045C19.4065 7.2277 19.4065 6.77096 19.1237 6.48821L18.1015 5.46597C17.8187 5.18322 17.362 5.18322 17.0792 5.46597C16.7965 5.74871 16.7965 6.20546 17.0792 6.48821Z",
    fill: "#FFFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9257 7.51045L11.948 6.48821C12.2307 6.20546 12.2307 5.74871 11.948 5.46597C11.6652 5.18322 11.2085 5.18322 10.9257 5.46597L9.90347 6.48821C9.62072 6.77096 9.62072 7.2277 9.90347 7.51045C10.1862 7.7932 10.643 7.7932 10.9257 7.51045Z",
    fill: "#FFFEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4979 5.80041C16.0996 5.80041 17.3981 4.50194 17.3981 2.9002C17.3981 1.29847 16.0996 0 14.4979 0C12.8961 0 11.5977 1.29847 11.5977 2.9002C11.5977 4.50194 12.8961 5.80041 14.4979 5.80041Z",
    fill: "#FFFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8502 3.62427H20.3C20.699 3.62427 21.0252 3.29802 21.0252 2.89905C21.0252 2.50008 20.699 2.17383 20.3 2.17383H18.8502C18.4512 2.17383 18.125 2.50008 18.125 2.89905C18.125 3.29802 18.4512 3.62427 18.8502 3.62427Z",
    fill: "#FFFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70178 3.62427H10.1515C10.5505 3.62427 10.8768 3.29802 10.8768 2.89905C10.8768 2.50008 10.5505 2.17383 10.1515 2.17383H8.70178C8.30281 2.17383 7.97656 2.50008 7.97656 2.89905C7.97656 3.29802 8.30281 3.62427 8.70178 3.62427Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarConsumption);
export default __webpack_public_path__ + "static/media/solar-consumption.2154d12b52606535156584035f3e1b03.svg";
export { ForwardRef as ReactComponent };